import QAQuestionEntity from "./qa_question.entity";

export interface IQACategoryEntity {
    id: string;
    title: string;
    description: string;
    agentId: string;
    questions: QAQuestionEntity[];
}

export default class QACategoryEntity implements IQACategoryEntity {

    id: string;
    title: string;
    description: string;
    agentId: string;
    questions: QAQuestionEntity[];

    constructor(_: IQACategoryEntity) {
        this.id = _.id;
        this.title = _.title;
        this.description = _.description;
        this.questions = _.questions;
        this.agentId = _.agentId;
    }

    getTotalPointsResponse = (): number | null => {
        const applicableQuestions = this.questions.filter(q => q.response?.answer !== "Not Applicable");
        if (applicableQuestions.length === 0) return null;
        return applicableQuestions.reduce((acc, q) => acc + (q.response?.points || 0), 0);
    }
    


    getPercentageOfPoints = (): number => {
        const totalPoints = this.getTotalPointsResponse();
        if (totalPoints === null) return 0;
        return (totalPoints / this.getMaxQuestionPoints()) * 100;
    }

    getMaxQuestionPoints = (): number => {
        return this.questions
            .filter(q => q.response?.answer !== "Not Applicable")
            .reduce((acc, q) => acc + q.points, 0);
    }
    
}